<script setup lang="ts">
    import type { AsyncDataRequestStatus } from '#app';
    import type { ProductsCollectionData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';
    import type { ProductPreview } from '~/graphql/generated';

    /**
     * Products Widget Container
     * loads a collection via the api and renders a set of cards for each product
     * while loading the collection, a skeleton should be rendered
     * we only fetch the first collection in the array
     */
    const props = defineProps<IWidgetProps<ProductsCollectionData>>();
    const { data } = useWidget(props);

    const id = data.collections?.length ? `${data.collections[0].id}` : '';

    const fetchListData = async (key?: string) => {
        if (!key || key === '') {
            console.log(`no cache key available for ProductWidgetContainer id: ${key}`);
            return {
                status: ref<AsyncDataRequestStatus>('success'),
                error: ref(),
                data: [],
            };
        }
        return await useAsyncData<ProductPreview[]>(key, () => {
            return new Promise((resolve, reject) => {
                const { data: cachedData } = useNuxtData(id);
                const cache = cachedData ? unref(cachedData) : undefined;
                const { queryParams } = usePreview();

                if (cache) {
                    resolve(cache);
                    // console.log('query async product data');
                } else {
                    $fetch('/api/collection', {
                        query: {
                            id: key,
                            ...queryParams.value,
                        },
                    })
                        .then((response) => {
                            if (response?.data?.collection?.products?.items) {
                                const prods = response.data.collection.products.items as Array<ProductPreview>;
                                resolve(prods);
                            } else {
                                reject(new Error(`no data was received for collection ${id}`));
                            }
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }
            });
        });
    };
    const { data: products, error, status } = await fetchListData(id);

    const background = computed(() => {
        return data.style?.background_color;
    });
    onMounted(() => {
        /**
         * push gtm and webgains events
         */
        /*
        app.$webgains.pushEvent({
            pageType: 'category',
            categoryId: response.data.collection.handle,
            categoryName: response.data.collection.title,
        });
        */
    });
</script>
<template>
    <!-- Empty div fixes the hydration issue -->
    <org-product-grid
        v-if="status === 'success' && products?.length"
        :products="products"
        :background="background"
        :intro="data.intro" />
    <div v-else></div>
</template>
